<div class="h-100">
  <div class="cargo-tab flex align-items-center w-100 border--bottom-grey padding-xxl-20">
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Cargo name</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Cargo weight</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">L x H x W</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Cargo type</div>
    <div class="flex-1 font--xxl-11 font-500 color-sky-blue">Vehicle requirements</div>
    <div></div>
  </div>
  <div class="body-all overflow-y--scroll">
    <div *ngIf="isLoading" class="w-100 h-100 loader">
      <app-loader class="w-100 h-100"></app-loader>
    </div>
    <div *ngIf="loads && loads.length > 0 && !isLoading">
      <div
        *ngFor="let load of loads"
        class="cargo-tab flex position-relative align-items-center body-all-one border--bottom-grey padding-xxl--left-20 padding-xxl--right-20"
      >
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">{{ load?.name }}</div>
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">{{ load?.weight }}</div>
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
          {{ load?.measures?.length ? load?.measures.length + ' x' : '' }}
          {{ load?.measures?.height ? load?.measures.height + ' x' : '' }}
          {{ load?.measures?.width }}{{ load?.measures?.unit }}
        </div>
        <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
          {{ load?.loadType }}
        </div>
        <div class="flex-1 font--xxl-13 font-regular color-dark-blue">
          {{
            load?.vehicleRequirements ? convertVehicleRequirementsToString(load?.vehicleRequirements) : 'Not entered'
          }}
        </div>
        <div (click)="showPopupDots(load.id)" class="cursor-pointer margin-xxl--right-25">
          <img alt="" src="/assets/images/icons/dots.svg" />
        </div>
        <!-- dots -->
        <div
          [ngStyle]="{
            opacity: openDots && loadId === load.id ? '1' : '0',
            'pointer-events': openDots && loadId === load.id ? 'all' : 'none'
          }"
          (mouseleave)="openDots = false"
          class="dots flex flex-column justify-content-center"
        >
          <div (click)="onEditLoad(load)" class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer">
            Edit Cargo
          </div>
          <div (click)="deleteLoad(load)" class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer">
            Delete Cargo
          </div>
        </div>
      </div>
    </div>
    <!-- empty screen cargo-->
    <div *ngIf="(!loads || loads.length === 0) && !isLoading" class="flex justify-content-center">
      <div class="empty-screen flex flex-column align-items-center justify-content-center">
        <img class="margin-xxl--bottom-48" src="/assets/images/emptyScreen/templates.svg" alt="" />
        <div class="font--xxl-16 font-regular text-center color-dark-blue">
          Here, you can manage your Cargo Templates.
        </div>
        <div class="font--xxl-16 font-regular text-center color-dark-blue margin-xxl--bottom-24">
          Cargo Templates allow you to fill in cargo forms with just one click when you create a new job. This can save
          you a lot of time.
        </div>
        <div class="font--xxl-16 font-regular text-center color-dark-blue">
          Add your first Cargo Template via the plus symbol in the top-right corner.
        </div>
      </div>
    </div>
  </div>
</div>
